import { render, staticRenderFns } from "./ChooseRole.vue?vue&type=template&id=7a754dbc&"
import script from "./ChooseRole.vue?vue&type=script&lang=js&"
export * from "./ChooseRole.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports